export const sportsContent = {
    fr: {
        eyebrow: 'SPORT EN DIRECT',
        title: 'Découvrez tous les canaux sportifs et vos compétitions préférées dans un seul abonnement.',
        leagueOrder: ['Ligue 1', 'UEFA Champions League', 'La Liga', 'Premier League', 'Ligue 2', 'Serie A', 'Bundesliga', 'UEFA Europa League', 'Jupiler Pro League', 'Saudi League', 'F1', 'UFC'],
    },
    es: {
        eyebrow: 'DEPORTE EN DIRECTO',
        title: 'Descubre todos los canales deportivos y tus competiciones favoritas en una sola suscripción.',
        leagueOrder: ['La Liga', 'UEFA Champions League', 'Premier League', 'Serie A', 'Bundesliga', 'Ligue 1', 'UEFA Europa League', 'Ligue 2', 'Jupiler Pro League', 'Saudi League', 'F1', 'UFC'],
    },
};
